import styled, { css } from 'styled-components';

export const Button = styled.button`
  background-color: ${(props) => {
    if (props.program === 'young') return '#8acfd9';
    if (props.program === 'whatsapp') return '#29A71A';
    return '#1EAB61';
  }};
  padding: ${(props) =>
    props.program && props.program === 'young' ? '1.5rem 3rem' : '8px 20px'};
  font-size: 1.8rem;
  border-radius: 8px;

  border: none;
  color: #fff;
  font-weight: 900;
  border: ${(props) =>
    props.program && props.program === 'young' ? '2px solid #8acfd9' : 'none'};
  transition:
    background 0.4s,
    color 0.4s,
    border 0.4s,
    font-weight 0.4s;

  &:hover {
    opacity: ${(props) =>
      props.program && props.program === 'young' ? 'none' : '0.7'};
    background-color: ${(props) =>
      props.program && props.program === 'young' ? '#f4f4f4' : '#1EAB61'};
    color: ${(props) =>
      props.program && props.program === 'young' ? '#8acfd9' : '#fff'};
  }

  ${(props) =>
    props.largeButton
      ? css`
          border-radius: 70px;
          width: 180px;
          height: 42px;
          display: flex;
          justify-content: center;
          font-size: 2.4rem;

          @media (max-width: 780px) {
            width: 145px;
            height: 34px;
            font-size: 1.6rem;
          }
        `
      : ''}

  ${(props) =>
    props.disabled &&
    !props.loading &&
    css`
      background-color: #e0e0e0;
      color: #a0a0a0;
      cursor: not-allowed;
      opacity: 0.6;
    `}
`;

export const Anchor = styled(Button.withComponent('a'))`
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin-top: 10px;
    text-align: center;
  }
`;
